// import React, { useState, useEffect } from 'react';
// import Header from '../components/header';
// import Footer from '../components/footer';
// import ToastCustom from '../components/toast';
// import EditCustomer from '../SheetContent/EditCustomer';
// import AddCustomer from '../SheetContent/AddCustomer';
// import { useNavigate } from 'react-router-dom';
// import Colors from '../components/Colors';
// import { MdEdit } from "react-icons/md";
// import { MdDelete } from "react-icons/md";
// import { IoIosPrint } from "react-icons/io";
// import BottomSheet2 from '../components/BottomSheet/BottomSheet2';
// import { pdfLink } from '../components/Strings';
// const CustomersPage = () => {
//   const [customers, setCustomers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState('All');
//   const [toastMessage, setToastMessage] = useState(null);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [isBottomSheetVisible, setBottomSheetVisible] = useState(false);
//   const [sheetContent, setSheetContent] = useState(null);
//   const navigate = useNavigate();
//   const openBottomSheet = (content) => {
//     setSheetContent(content);
//     setBottomSheetVisible(true);
//   };

//   const closeBottomSheet = () => {
//     setBottomSheetVisible(false);
//     setSheetContent(null);
//   };

  
//   useEffect(() => {
//     const fetchCustomers = async () => {
//       try {
//         const response = await fetch('https://app.mirzawaleed.com/getCustomers.php');
//         const data = await response.json();
//         setCustomers(data);
//       } catch (error) {
//         console.error('Error fetching customers:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCustomers();
//   }, []);

//   const handleFilterChange = (newFilter) => {
//     setFilter(newFilter);
//   };
//   const handlePrintPdf = (customerId) => {
//     const url = `${pdfLink}/onecustomerpdf.php?id=${customerId}`;
//     window.open(url, '_blank');
//   };
//   const handleClickListener = (customerId) => {
//     navigate(`/customer/${customerId}`); 
//   };
//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value);
//   };

//   const handleDelete = async (customerId) => {
//     try {
//       const response = await fetch(`https://app.mirzawaleed.com/deleteCustomer.php`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ id: customerId }),
//       });
  
//       const result = await response.json();
  
//       if (result.success) {
//         setToastMessage(`Customer with ID ${customerId} deleted successfully.`);
//       } else {
//         setToastMessage(`Failed to delete customer with ID ${customerId}: ${result.message}`);
//       }
//     } catch (error) {
//       console.error('Error deleting customer:', error);
//       setToastMessage(`Error deleting customer with ID ${customerId}: ${error.message}`);
//     }
//     setTimeout(() => setToastMessage(null), 3000);
//   };

  
//   const filteredCustomers = customers.filter((customer) => {
//     const matchesFilter = filter === 'All' || customer.location === filter;
//     const matchesSearch = customer.name.toLowerCase().includes(searchQuery.toLowerCase());
//     return matchesFilter && matchesSearch;
//   });

//   if (loading) return (
//     <p style={{ textAlign: 'center' }}>Loading Customer.....</p>);

//   return (
//     <>
//       <Header />
//       <div style={{ padding: '80px 20px 20px 20px' }}>
//         <h1 style={{ textAlign: 'center' }}>Customers</h1>
//         <center>
//         <button style={{
//           width:'300px',
//           padding:'6px',
//           background:Colors.primary,
//           color:'white',
//           borderRadius:'6px',
//           cursor:'pointer',
//           margin:'8px'
//           }} onClick={() => navigate('/addcustomer')}>Add Customers</button>
//         </center>
//         <div style={{ marginBottom: '20px', textAlign: 'center' }}>
//           <input
//             type="text"
//             placeholder="Search customers by name"
//             value={searchQuery}
//             onChange={handleSearchChange}
//             style={searchInputStyle}
//           />
//         </div>

//         {/* Tab Navigation */}
//         <div style={tabContainerStyle}>
//           <button onClick={() => handleFilterChange('All')} style={tabStyle(filter === 'All')}>All</button>
//           <button onClick={() => handleFilterChange('Sarai')} style={tabStyle(filter === 'Sarai')}>Sarai Alamgir</button>
//           <button onClick={() => handleFilterChange('Jhelum')} style={tabStyle(filter === 'Jhelum')}>Jhelum</button>
//           <button onClick={() => handleFilterChange('Kharian')} style={tabStyle(filter === 'Kharian')}>Kharian</button>
//         </div>

//         {filteredCustomers.length === 0 ? (
//           <p>No customers found.</p>
//         ) : (
//           <ul style={{ listStyle: 'none', padding: 0 }}>
//             {filteredCustomers.map((customer) => (
//               <li key={customer.id} style={customerItemStyle}>
//                 <div  onClick={() => handleClickListener(customer.id)}>
//                   <strong>{customer.name}</strong>
//                   <p>Phone: {customer.phone}</p>
//                   <p>Total Pending: {customer.total_pending}</p>
//                 </div>
//                 <div style={actionButtonContainerStyle}>
//                   <button onClick={() => handlePrintPdf(customer.id)}  
//                   style={{ 
//                     padding: '5px 10px',
//                     color: '#FFF',
//                     border: 'none',
//                     borderRadius: '3px',
//                     cursor: 'pointer',
//                     flexGrow: 1, 
//                     color:Colors.primary, 
//                     marginRight: '10px',
//                     fontSize:'30px',
//                     backgroundColor:'none',
//                     background:'none',
//                     cursor:'pointer',
//                     border:'none' }}><IoIosPrint /></button>
//                   <button onClick={() => openBottomSheet(<EditCustomer customerId={customer.id}/>)} style={{ 
//                     padding: '5px 10px',
//                     color: '#FFF',
//                     border: 'none',
//                     borderRadius: '3px',
//                     cursor: 'pointer',
//                     flexGrow: 1, 
//                     color:Colors.primary, 
//                     marginRight: '10px',
//                     fontSize:'30px',
//                     backgroundColor:'none',
//                     background:'none',
//                     cursor:'pointer',
//                     border:'none' }}><MdEdit /></button>
//                   <button onClick={() => handleDelete(customer.id)} style={{ 
//                     padding: '5px 10px',
//                     color: '#FFF',
//                     border: 'none',
//                     borderRadius: '3px',
//                     cursor: 'pointer',
//                     flexGrow: 1, 
//                     color:Colors.primary, 
//                     marginRight: '10px',
//                     fontSize:'30px',
//                     backgroundColor:'none',
//                     background:'none',
//                     cursor:'pointer',
//                     border:'none' }}> <MdDelete /></button>
//                 </div>
//               </li>
//             ))}
//           </ul>
//         )}
//       </div>
//       <br></br>
//       <br></br>
//       <br></br>
//       <Footer />

//       {toastMessage && <ToastCustom message={toastMessage} onClose={() => setToastMessage(null)} />}
//       <BottomSheet2 isVisible={isBottomSheetVisible} onClose={closeBottomSheet}>
//         {sheetContent}
//       </BottomSheet2>
//     </>
//   );
// };

// // Styles for the search input field
// const searchInputStyle = {
//   width: '100%',
//   maxWidth: '400px',
//   padding: '10px',
//   fontSize: '16px',
//   borderRadius: '5px',
//   border: '1px solid #ccc',
//   outline: 'none',
// };

// // Styles for the tab container
// const tabContainerStyle = {
//   display: 'flex',
//   justifyContent: 'center',
//   marginBottom: '20px',
//   borderBottom: '1px solid #ccc',
// };

// // Styles for individual tabs
// const tabStyle = (isActive) => ({
//   flex: 1,
//   textAlign: 'center',
//   padding: '10px 0',
//   cursor: 'pointer',
//   backgroundColor:'none',
//   background:'none',
//   border:'none',
//   color: isActive ? '#000' : '#888',
//   borderBottom: isActive ? '3px solid #007BFF' : 'none',
//   fontSize: '16px',
//   fontWeight: isActive ? 'bold' : 'normal',
// });

// // Styles for customer list items
// const customerItemStyle = {
//   display: 'flex',
//   justifyContent: 'space-between',
//   alignItems: 'center',
//   marginBottom: '10px',
//   padding: '20px',
//   backgroundColor: '#f9f9f9',
//   borderRadius: '5px',
//   boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
// };

// // Styles for the action button container
// const actionButtonContainerStyle = {
//   display: 'flex',
//   justifyContent: 'center',
//   gap: '10px',
// };

// // Styles for individual action buttons
// const actionButtonStyle = (backgroundColor) => ({
//   padding: '5px 10px',
//   backgroundColor,
//   color: '#FFF',
//   border: 'none',
//   borderRadius: '3px',
//   cursor: 'pointer',
//   flexGrow: 1,
// });

// export default CustomersPage;
import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import ToastCustom from '../components/toast';
import EditCustomer from '../SheetContent/EditCustomer';
import AddCustomer from '../SheetContent/AddCustomer';
import { useNavigate } from 'react-router-dom';
import Colors from '../components/Colors';
import { MdEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { IoIosPrint } from "react-icons/io";
import BottomSheet2 from '../components/BottomSheet/BottomSheet2';
import { pdfLink } from '../components/Strings';

const CustomersPage = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('All');
  const [toastMessage, setToastMessage] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [isBottomSheetVisible, setBottomSheetVisible] = useState(false);
  const [sheetContent, setSheetContent] = useState(null);

  const navigate = useNavigate();

  const openBottomSheet = (content) => {
    setSheetContent(content);
    setBottomSheetVisible(true);
  };

  const closeBottomSheet = () => {
    setBottomSheetVisible(false);
    setSheetContent(null);
  };

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await fetch('https://app.mirzawaleed.com/getCustomers.php');
        const data = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error('Error fetching customers:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomers();
  }, []);

  // 🔥 Auto-Generated Locations (Dynamic Tabs)
  const locations = ['All', ...new Set(customers.map(c => c.location))];

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  const handlePrintPdf = (customerId) => {
    const url = `${pdfLink}/onecustomerpdf.php?id=${customerId}`;
    window.open(url, '_blank');
  };

  const handleClickListener = (customerId) => {
    navigate(`/customer/${customerId}`);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleDelete = async (customerId) => {
    try {
      const response = await fetch(`https://app.mirzawaleed.com/deleteCustomer.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: customerId }),
      });

      const result = await response.json();

      if (result.success) {
        setToastMessage(`Customer deleted successfully.`);
        setCustomers((prev) => prev.filter((c) => c.id !== customerId));
      } else {
        setToastMessage(`Delete failed: ${result.message}`);
      }
    } catch (error) {
      console.error('Error deleting customer:', error);
      setToastMessage(`Error: ${error.message}`);
    }
    setTimeout(() => setToastMessage(null), 3000);
  };

  const filteredCustomers = customers.filter((customer) => {
    const matchesFilter = filter === 'All' || customer.location === filter;
    const matchesSearch = customer.name.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  if (loading)
    return <p style={{ textAlign: 'center' }}>Loading Customers...</p>;

  return (
    <>
      <Header />

      <div style={{ padding: '80px 20px 20px 20px' }}>
        <h1 style={{ textAlign: 'center' }}>Customers</h1>

        <center>
          <button
            style={{
              width: '300px',
              padding: '6px',
              background: Colors.primary,
              color: 'white',
              borderRadius: '6px',
              cursor: 'pointer',
              margin: '8px'
            }}
            onClick={() => navigate('/addcustomer')}
          >
            Add Customer
          </button>
        </center>

        {/* Search */}
        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
          <input
            type="text"
            placeholder="Search customers by name"
            value={searchQuery}
            onChange={handleSearchChange}
            style={searchInputStyle}
          />
        </div>

        {/* 🔥 Dynamic Tabs */}
        <div style={tabContainerStyle}>
          {locations.map((loc) => (
            <button
              key={loc}
              onClick={() => handleFilterChange(loc)}
              style={tabStyle(filter === loc)}
            >
              {loc}
            </button>
          ))}
        </div>

        {filteredCustomers.length === 0 ? (
          <p>No customers found.</p>
        ) : (
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {filteredCustomers.map((customer) => (
              <li key={customer.id} style={customerItemStyle}>
                <div onClick={() => handleClickListener(customer.id)} style={{ cursor: 'pointer' }}>
                  <strong>{customer.name}</strong>
                  <p>Phone: {customer.phone}</p>
                  <p>Total Pending: {customer.total_pending}</p>
                </div>

                <div style={actionButtonContainerStyle}>
                  <button onClick={() => handlePrintPdf(customer.id)} style={iconButtonStyle}><IoIosPrint /></button>
                  <button onClick={() => openBottomSheet(<EditCustomer customerId={customer.id} />)} style={iconButtonStyle}><MdEdit /></button>
                  <button onClick={() => handleDelete(customer.id)} style={iconButtonStyle}><MdDelete /></button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>

      <Footer />

      {toastMessage && <ToastCustom message={toastMessage} onClose={() => setToastMessage(null)} />}

      <BottomSheet2 isVisible={isBottomSheetVisible} onClose={closeBottomSheet}>
        {sheetContent}
      </BottomSheet2>
    </>
  );
};

// ===== STYLES =====

const searchInputStyle = {
  width: '100%',
  maxWidth: '400px',
  padding: '10px',
  fontSize: '16px',
  borderRadius: '5px',
  border: '1px solid #ccc'
};

const tabContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '20px',
  borderBottom: '1px solid #ccc',
  flexWrap: 'wrap'
};

const tabStyle = (isActive) => ({
  padding: '10px 18px',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  fontSize: '16px',
  margin: '0px 4px',
  fontWeight: isActive ? 'bold' : 'normal',
  borderBottom: isActive ? `3px solid ${Colors.primary}` : 'none',
  color: isActive ? Colors.primary : '#888',
});

const customerItemStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '10px',
  padding: '20px',
  backgroundColor: '#f9f9f9',
  borderRadius: '5px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
};

const actionButtonContainerStyle = {
  display: 'flex',
  gap: '10px',
};

const iconButtonStyle = {
  fontSize: '26px',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: Colors.primary,
};

export default CustomersPage;
